import MenuItem from "layout/Menu/MenuItem";
import { ReactComponent as MailIcon } from "assets/images/icons/mail.svg";
import { ReactComponent as SearchIcon } from "assets/images/icons/search.svg";
import { ReactComponent as HelpIcon } from "assets/images/icons/help.svg";
import { useAccount } from "context/AccountContext";

function TopMenuList({ onClick }) {
  const { user } = useAccount();

  const navigation = [
    { title: 'Help', link: '/help', icon: <HelpIcon/> },
    { title: 'Leden zoeken', link: '/leden', icon: <SearchIcon/>, needsAuthentication: true },
    { title: 'Berichtenbox', link: '/berichtenbox', icon: <MailIcon/>, needsAuthentication: true },
  ];

  return (
    <>
      {
        navigation.map(
          item => (
            <MenuItem
              key={ item.title }
              title={ item.title }
              link={ item.link }
              icon={ item.icon }
              disabled={ item.needsAuthentication && !user }
              onClick={ onClick }
              mobileOnly={ item.mobileOnly }
            />
          )
        )
      }
    </>
  );
}


export default TopMenuList;
